import interest from "./img/principles/interest.svg";
import informality from "./img/principles/informality.svg";
import winwin from "./img/principles/win-win.svg";
import atmosphere from "./img/principles/atmosphere.svg";
import comfort from "./img/principles/comfort.svg";
import development from "./img/principles/development.svg";
import interestGreen from "./img/principles/interest-green.svg";
import informalityGreen from "./img/principles/informality-green.svg";
import winwinGreen from "./img/principles/win-win-green.svg";
import atmosphereGreen from "./img/principles/atmosphere-green.svg";
import comfortGreen from "./img/principles/comfort-green.svg";
import developmentGreen from "./img/principles/development-green.svg";

export default [
  {
    icon: interest,
    iconGreen: interestGreen,
    title: "Вовлеченность",
    description:
      "Наша команда — это люди, которые работают не только из-за зарплаты. Сотрудникам важен результат и интересен рабочий процесс. Мы внимательно следим за тем, чтобы никто не устал и не заскучал.",
  },
  {
    icon: informality,
    iconGreen: informalityGreen,
    title: "Открытость",
    description:
      "Мы отказались от бюрократии: чтобы обратиться к бухгалтеру или руководителю, достаточно просто подойти со своим вопросом. Любые вопросы можно обсудить лично, по телефону или в Slack.",
  },
  {
    icon: winwin,
    iconGreen: winwinGreen,
    title: "Win-Win",
    description:
      "Мы осознаем, что у нас и наших клиентов общая цель и общий успех. Поэтому каждый член команды заинтересован в развитии проекта и, если нужно, в поиске компромисса.",
  },
  {
    icon: atmosphere,
    iconGreen: atmosphereGreen,
    title: "Атмосфера",
    description:
      "Мы понимаем, что каждый сотрудник нашего коллектива важен и часто от работы одного сотрудника зависит успех всей команды. Чтобы команда была сплоченней, мы поддерживаем дружескую атмосферу: ходим на квесты и в бары все вместе. Редко, но метко.",
  },
  {
    icon: comfort,
    iconGreen: comfortGreen,
    title: "Комфорт",
    description:
      "У нас комфортный и светлый офис, в котором ничего не будет отвлекать вас от работы, зато будут чай, кофе и прочие вкусности. Рабочие места оборудованы всем необходимым в соответствии со 2 классом условий труда и соответствуют всем требованиям законодательства РФ.",
  },
  {
    icon: development,
    iconGreen: developmentGreen,
    title: "Развитие",
    description:
      "Мы ценим своих сотрудников и поддерживаем стремление каждого к саморазвитию, особенно если это помогает бизнесу. Наши сотрудники посещают профессиональные конференции, проходят онлайн-тренинги и курсы. Мы всегда за новые знания, идеи и технологии!",
  },
];
